<script lang="ts">
  import { fly } from "svelte/transition";
  import { careersMapItem } from "$stores";
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  import RichText from "../RichText.svelte";
  export let blok: any;
  export let jobs: any[] = [];

  $: matches = jobs.filter((j) => j.location.name.endsWith(blok.name));
  $: match = matches.length > 0 ? matches[0] : null;

  $: url = match
    ? `/careers/open-roles?loc=${encodeURIComponent(blok.name)}`
    : "#";

  $: noMatches = matches.length === 0;
  /** Dispatch event on click outside of node */
  function clickOutside(node) {
    const handleClick = (event) => {
      if (node && !node.contains(event.target) && !event.defaultPrevented) {
        node.dispatchEvent(new CustomEvent("click_outside", node));
      }
    };

    document.addEventListener("click", handleClick, true);

    return {
      destroy() {
        document.removeEventListener("click", handleClick, true);
      },
    };
  }

  function handleClickOutside(e) {
    careersMapItem.set("");
  }

  // console.log(blok?.textCard);
</script>

<div
  class="relative"
  tabindex="-1"
  role="button"
  on:click={() =>
    blok?.textCard?.length
      ? careersMapItem.set($careersMapItem === blok.name ? "" : blok.name)
      : null}
  on:keydown={() =>
    blok?.textCard?.length
      ? careersMapItem.set($careersMapItem === blok.name ? "" : blok.name)
      : null}
  use:clickOutside
  on:click_outside={handleClickOutside}
>
  {#if $careersMapItem === blok.name && blok?.textCard?.length > 0}
    <div
      transition:fly|global
      class="hidden sm:block absolute bottom-0 left-0 pb-8 pl-12"
    >
      <a
        href={url}
        class="bg-white p-6 md:p-8 shadow-[14px_15px_52px_0px_rgba(0,_0,_0,_0.06)] rounded w-[40vw] md:w-[33vw] max-w-[410px] no-underline text-inherit block {matches.length >
        0
          ? ''
          : 'pointer-events-none'}"
      >
        <div>
          <div class="text-[16px] font-bold mb-3 text-black">
            {blok.textCard[0].heading}
          </div>
          {#if noMatches}
            <p class="type:body-small">
              There are currently no open roles in our {blok.name} locations. Please
              check back later.
            </p>
          {:else}
            <RichText
              class="type:body-small"
              blok={noMatches ? {} : blok.textCard[0]}
            />
          {/if}
        </div>

        {#if matches.length > 0}
          <div class="mt-12">
            <ArrowLink class="reduced hover-red-bg">See openings</ArrowLink>
          </div>
        {/if}
      </a>
    </div>
  {/if}

  <!-- {#if match} -->
  <div
    class="{$careersMapItem === blok.name
      ? 'bg-red'
      : 'bg-black hover:bg-red'} relative block no-underline text-white text-[12px] font-bold rounded-[2rem] p-[1px_.9em] cursor-pointer transition-colors duration-150 {blok
      ?.textCard?.length > 0
      ? ''
      : 'pointer-events-none'}"
  >
    <div class="pt-[1px] {matches.length === 0 ? 'opacity-0s' : ''}">
      {matches.length}
    </div>
  </div>
  <!-- {:else}
		<div class="bg-black relative block rounded-full h-[11px] w-[11px]" />
	{/if} -->
</div>
